import useFetchInfinite from 'lib/hooks/useFetchInfinite';

import {
  ArticleCard,
  FeaturedArticle,
  LoadMore,
} from '@frontendmentorio/design-system-v2';

export default function Index({ data }) {
  const {
    data: { data: articles, meta },
    isLoading,
    setPage,
  } = useFetchInfinite('/api/v3/articles?filter=platform|learning', {
    fallbackData: data,
  });

  return (
    <>
      <FeaturedArticle
        article={articles[0]}
        href={`/articles/${articles[0].slug}`}
      />

      <div className="bg-gray-100 flex flex-col gap-6 items-center px-5 py-8">
        <ul className="container-xl gap-6 grid grid-cols-1 mobile:grid-cols-2 desktop:grid-cols-3">
          {articles.slice(1).map((article) => (
            <ArticleCard
              article={article}
              href={`/articles/${article.slug}`}
              key={article.id}
            />
          ))}
        </ul>

        {meta?.page.next && (
          <LoadMore
            isLoading={isLoading}
            onClick={() => setPage(meta.page.next)}
          >
            Load more
          </LoadMore>
        )}
      </div>
    </>
  );
}
